import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
import isSameOrAfter from "dayjs/plugin/isSameOrAfter.js";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
import generateTour from './generateTour.js';
import generateMeal from './generateMeal.js';
import generateOffTime from './generateOfftime.js';
import generateAssignments from './generateAssignments.js';
import getOffsetTime from '../../../../../utils/getOffsetTime.js';
import generatePayTransactionItem from './generatePayTransactionItem.js';
import generateDayOffRequest from './generateDayOffRequest.js';
import _ from 'lodash';
import generateIndicators from './generateIndicators.js';
import daylightSavingsCheck from '../../../../../utils/daylightSavingsCheck.js';

const undefined = 'undefined';

/**
 * Takes in a posted schedule for a resource collection and returns an array of schedule items for
 * the seven and nine day schedule ordered by time and day.
 * @param {*} schedule
 */
const generateItems = (schedule, startDate, scheduleType, scheduleFormat,securityLevels) => {
    const scheduleLength =  schedule ? schedule.length || 0 : 0;
    // startDate is only used in postedSchedules for DST adjustments
    // startDate is at midnight UTC, adding 12 hours to ensure date falls on same date for almost any local time zone after adjustments
    startDate = dayjs(dayjs(startDate).add(12, 'hour'));

    if (schedule) {
        let timeZoneOffset;
        const items ={};
        for (let resource of schedule) {
            const { rId } = resource;
            items[rId] = [];

            if (resource.dayTypes) {

                // eslint-disable-next-line no-unused-vars
                for (let [rdtId, dayType] of Object.entries(resource.dayTypes)) {

                    if (dayType.tour) {
                        const { startTime, tourPayTransactions, tourIndicators, assignments, meal } = dayType.tour;

                        let tourStartTime = dayjs(dayjs.unix(startTime).utc().format("YYYY-MM-DD HH:mm:ss"));

                        timeZoneOffset = 0;

                        let tourItems = [];
                        let orderedItems;
                        // tourStartTime = dayjs(tourStartTime).add(timeZoneOffset, 'minute');
                        items[rId].push(generateTour(startTime, dayType, resource, startDate, scheduleType, scheduleFormat, timeZoneOffset,securityLevels));

                        if (assignments) {
                            for (let assignment of Object.entries(assignments)) {
                                tourItems.push(assignment[1]);
                            }
                        }

                        orderedItems = orderItems(tourItems);
                        tourItems = [];

                        let assignmentCase = 0;
                        for (let orderedItem of orderedItems) {
                            items[rId].push(generateAssignments(resource, dayType, orderedItem, assignmentCase, startTime, timeZoneOffset, startDate, scheduleType, scheduleFormat, scheduleLength));

                                if (assignmentCase >= 2) {
                                    assignmentCase = 0;
                                } else {
                                    assignmentCase++;
                            }
                        }
                        if (meal) {
                            items[rId].push(generateMeal(resource.rId, dayType, tourStartTime, timeZoneOffset, startDate, scheduleType, scheduleFormat, scheduleLength));
                        }
                        if (tourPayTransactions && tourPayTransactions.length > 0) {
                            items[rId].push(generatePayTransactionItem(resource.rId, dayType, startTime));
                        }
                        //  in liveSchedule: dayType.remoteIndicator
                        // in postedSchedule: dayType.tour.remoteIndicator
                        if ((tourIndicators && tourIndicators !== undefined && tourIndicators.length > 0) || dayType.remoteIndicator || dayType.tour.remoteIndicator) {
                            items[rId].push(generateIndicators(resource.rId, dayType, tourStartTime));
                        }
                    } else if (dayType.dayOff) {
                        let dayOffStartTime = dayjs(dayjs.unix(dayType.dayOff.startTime).utc().format("YYYY-MM-DD HH:mm:ss"));
                        timeZoneOffset = 0;//!timeZoneOffset ? timeZoneOffset = getOffsetTime(dayOffStartTime) : timeZoneOffset;
                        // adding two timeZoneOffsets here just to quick-fix DST issue
                        items[rId].push(generateOffTime(resource, dayType, dayOffStartTime));

                    } else if (dayType.dayOffRequest) {
                        // Fixes the timezone isssues
                        let dayOffStartTime = dayjs(dayjs.unix(dayType.dayOffRequest.startTime).utc().format("YYYY-MM-DD HH:mm:ss"));
                        let dayOffEndTime = dayjs(dayjs.unix(dayType.dayOffRequest.endTime).utc().format("YYYY-MM-DD HH:mm:ss"));
                        timeZoneOffset =0;//!timeZoneOffset ? timeZoneOffset = getOffsetTime(dayOffStartTime) : timeZoneOffset;
                        // adding two timeZoneOffsets here just to quick-fix DST issue
                        
                        // Checking if the day off request goes over multple days.
                        let dayAmount = dayOffEndTime.diff(dayOffStartTime, 'day');
                        // Splitting days off that go over multiple days into day objects
                        if (dayAmount >= 1) {
                            let clonedDayType = _.cloneDeep(dayType);
                            let adjustedUnixStartTime = dayjs(dayjs.unix(clonedDayType.dayOffRequest.startTime).utc().format("YYYY-MM-DD HH:mm:ss")).unix();
                            let stringDorId;
                            for (let x = 0; x <= dayAmount; x++) {
                                if (x !== 0) {
                                    let startTime = dayjs.unix(adjustedUnixStartTime).add(x, 'day').unix();
                                    dayOffStartTime = dayjs(dayjs.unix(startTime).utc().format("YYYY-MM-DD HH:mm:ss"));
                                    stringDorId = stringDorId.slice(0, -1) + x;
                                } else stringDorId = clonedDayType.dayOffRequest.dorId + "-" + x;
                                items[rId].push(generateDayOffRequest(resource, clonedDayType, dayOffStartTime, stringDorId));
                            }
                        // if the day off request only goes over one day.
                        } else items[rId].push(generateDayOffRequest(resource, dayType, dayOffStartTime));

                    } else if (dayType.assignment) {
                        //let assignmentStartTime = dayjs.unix(dayType.assignment.startTime);
                        timeZoneOffset = 0
                        items[rId].push(generateAssignments(resource, dayType, dayType.assignment, 3, null, timeZoneOffset, startDate, scheduleType, scheduleFormat, scheduleLength));
                    }
                }
            }
        }

        let nestedItemrray = (Object.values(items));

        return [].concat.apply([], nestedItemrray);
    } else return [];
}

/**
 * Sorts an unordered array and returns an array of sorted items based on it's startTime.
 * @param {*Items can be assignments or meals object} items
 */
const orderItems = (items) => {
    let orderedArray = [];

    for (let item of Object.entries(items)) {

        // Ordering the items
        if (orderedArray.length === 0) {
            orderedArray.push(item[1]);
        } else {
            for (let x = 0; x < orderedArray.length; x++) {
                if (getItemStartTime(item[1]) < getItemStartTime(orderedArray[x])) {
                    orderedArray.splice(x, 0, item[1]);
                    break;
                }

                if (x === orderedArray.length - 1) {
                    orderedArray.push(item[1]);
                    break;
                }
            }
        }
    }
    return orderedArray;
}

/**
 * Recieves an item and returns the start time.
 * @param {*Item can be an assignment or meal object} item
 */
const getItemStartTime = (item) => {
    if (item.hasOwnProperty('mealTime')) {
        return item.mealTime;
    } else {
        return item.startTime;
    }
}

export default generateItems;
